import React, { useState, useEffect } from 'react';
import './MalasOrdenesGarantias.css';
import Header from '../common/Header';
import Footer from '../common/Footer';
import { useToast } from '../../contexts/ToastContext';
import { getApiUrl } from '../../utils/api';
import { FaSearch, FaSave, FaTimes } from 'react-icons/fa';

const MalasOrdenesGarantias = () => {
  const [pedidos, setPedidos] = useState([]);
  const [pedidoSeleccionado, setPedidoSeleccionado] = useState(null);
  const [productosPedido, setProductosPedido] = useState([]);
  const [productosMalaOrden, setProductosMalaOrden] = useState([]);
  const [productosGarantia, setProductosGarantia] = useState([]);
  const [loading, setLoading] = useState(false);
  const [guardando, setGuardando] = useState(false);
  const [busqueda, setBusqueda] = useState('');
  const toast = useToast();

  // Buscar pedido por número o mesa
  const buscarPedido = async () => {
    if (!busqueda.trim()) {
      toast.error('Por favor ingrese un número de pedido o mesa');
      return;
    }

    try {
      setLoading(true);
      const response = await fetch(getApiUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          tipo: 'getPedido',
          numeroPedido: busqueda
        })
      });

      const data = await response.json();

      if (data.success && data.data) {
        setPedidoSeleccionado(data.data);
        cargarProductosPedido(data.data.idPedido);
      } else {
        toast.error('No se encontró el pedido especificado');
        setPedidoSeleccionado(null);
        setProductosPedido([]);
      }
    } catch (error) {
      console.error('Error al buscar pedido:', error);
      toast.error('Error al buscar el pedido');
    } finally {
      setLoading(false);
    }
  };

  // Cargar productos del pedido
  const cargarProductosPedido = async (idPedido) => {
    try {
      const response = await fetch(getApiUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          tipo: 'getProductosPedido',
          idPedido: idPedido
        })
      });

      const data = await response.json();

      if (data.success) {
        setProductosPedido(data.data || []);
      }
    } catch (error) {
      console.error('Error al cargar productos:', error);
      toast.error('Error al cargar los productos del pedido');
    }
  };

  // Manejar entrada con tecla Enter
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      buscarPedido();
    }
  };

  // Agregar producto a mala orden
  const agregarMalaOrden = (producto) => {
    const existe = productosMalaOrden.find(p => p.idProducto === producto.idProducto);

    if (existe) {
      // Si ya existe, aumentar cantidad
      setProductosMalaOrden(productosMalaOrden.map(p =>
        p.idProducto === producto.idProducto
          ? { ...p, cantidad: p.cantidad + 1 }
          : p
      ));
    } else {
      // Si no existe, agregar con cantidad 1
      setProductosMalaOrden([...productosMalaOrden, {
        ...producto,
        cantidad: 1,
        motivo: ''
      }]);
    }

    // Remover de productos del pedido disponibles
    const nuevosProductos = productosPedido.map(p => {
      if (p.idProducto === producto.idProducto) {
        return { ...p, cantidad: p.cantidad - 1 };
      }
      return p;
    }).filter(p => p.cantidad > 0);

    setProductosPedido(nuevosProductos);
  };

  // Agregar producto a garantía
  const agregarGarantia = (producto) => {
    const existe = productosGarantia.find(p => p.idProducto === producto.idProducto);

    if (existe) {
      setProductosGarantia(productosGarantia.map(p =>
        p.idProducto === producto.idProducto
          ? { ...p, cantidad: p.cantidad + 1 }
          : p
      ));
    } else {
      setProductosGarantia([...productosGarantia, {
        ...producto,
        cantidad: 1,
        motivo: ''
      }]);
    }

    // Remover de productos del pedido disponibles
    const nuevosProductos = productosPedido.map(p => {
      if (p.idProducto === producto.idProducto) {
        return { ...p, cantidad: p.cantidad - 1 };
      }
      return p;
    }).filter(p => p.cantidad > 0);

    setProductosPedido(nuevosProductos);
  };

  // Remover producto de mala orden
  const removerMalaOrden = (producto) => {
    const productoMalaOrden = productosMalaOrden.find(p => p.idProducto === producto.idProducto);

    if (productoMalaOrden.cantidad > 1) {
      setProductosMalaOrden(productosMalaOrden.map(p =>
        p.idProducto === producto.idProducto
          ? { ...p, cantidad: p.cantidad - 1 }
          : p
      ));
    } else {
      setProductosMalaOrden(productosMalaOrden.filter(p => p.idProducto !== producto.idProducto));
    }

    // Devolver al pedido
    const existe = productosPedido.find(p => p.idProducto === producto.idProducto);
    if (existe) {
      setProductosPedido(productosPedido.map(p =>
        p.idProducto === producto.idProducto
          ? { ...p, cantidad: p.cantidad + 1 }
          : p
      ));
    } else {
      setProductosPedido([...productosPedido, { ...producto, cantidad: 1 }]);
    }
  };

  // Remover producto de garantía
  const removerGarantia = (producto) => {
    const productoGarantia = productosGarantia.find(p => p.idProducto === producto.idProducto);

    if (productoGarantia.cantidad > 1) {
      setProductosGarantia(productosGarantia.map(p =>
        p.idProducto === producto.idProducto
          ? { ...p, cantidad: p.cantidad - 1 }
          : p
      ));
    } else {
      setProductosGarantia(productosGarantia.filter(p => p.idProducto !== producto.idProducto));
    }

    // Devolver al pedido
    const existe = productosPedido.find(p => p.idProducto === producto.idProducto);
    if (existe) {
      setProductosPedido(productosPedido.map(p =>
        p.idProducto === producto.idProducto
          ? { ...p, cantidad: p.cantidad + 1 }
          : p
      ));
    } else {
      setProductosPedido([...productosPedido, { ...producto, cantidad: 1 }]);
    }
  };

  // Actualizar motivo
  const actualizarMotivo = (idProducto, motivo, tipo) => {
    if (tipo === 'malaOrden') {
      setProductosMalaOrden(productosMalaOrden.map(p =>
        p.idProducto === idProducto ? { ...p, motivo } : p
      ));
    } else {
      setProductosGarantia(productosGarantia.map(p =>
        p.idProducto === idProducto ? { ...p, motivo } : p
      ));
    }
  };

  // Guardar cambios
  const guardarCambios = async () => {
    if (!pedidoSeleccionado) {
      toast.error('No hay pedido seleccionado');
      return;
    }

    if (productosMalaOrden.length === 0 && productosGarantia.length === 0) {
      toast.error('No hay productos para registrar');
      return;
    }

    try {
      setGuardando(true);

      const response = await fetch(getApiUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          tipo: 'registrarMalasOrdenesGarantias',
          idPedido: pedidoSeleccionado.idPedido,
          productosMalaOrden: productosMalaOrden,
          productosGarantia: productosGarantia
        })
      });

      const data = await response.json();

      if (data.success) {
        toast.success('Registros guardados correctamente');
        // Limpiar formulario
        setPedidoSeleccionado(null);
        setProductosPedido([]);
        setProductosMalaOrden([]);
        setProductosGarantia([]);
        setBusqueda('');
      } else {
        toast.error(data.message || 'Error al guardar los registros');
      }
    } catch (error) {
      console.error('Error al guardar:', error);
      toast.error('Error al guardar los registros');
    } finally {
      setGuardando(false);
    }
  };

  // Cerrar/Limpiar formulario
  const cerrarFormulario = () => {
    setPedidoSeleccionado(null);
    setProductosPedido([]);
    setProductosMalaOrden([]);
    setProductosGarantia([]);
    setBusqueda('');
  };

  return (
    <div className="malas-ordenes-container">
      <Header
        titulo='Malas Órdenes y Garantías'
        color='#667eea'
      />
      <div className="malas-ordenes-content">
        <div className="malas-ordenes-inner">
          <div className="malas-ordenes-header">
            <h1 className="malas-ordenes-titulo">Registro de Malas Órdenes y Garantías</h1>
            <button
              onClick={cerrarFormulario}
              className="btn-cerrar"
              title="Cerrar"
            >
              <FaTimes /> Cerrar (Esc)
            </button>
          </div>

          {/* Panel de búsqueda */}
          <div className="panel-busqueda">
            <div className="busqueda-header">
              <h3 className="busqueda-titulo">🔍 Buscar Cuenta</h3>
            </div>
            <div className="busqueda-content">
              <div className="busqueda-row">
                <input
                  type="text"
                  placeholder="Número de pedido o mesa..."
                  value={busqueda}
                  onChange={(e) => setBusqueda(e.target.value)}
                  onKeyPress={handleKeyPress}
                  className="input-busqueda"
                  disabled={loading}
                />
                <button
                  onClick={buscarPedido}
                  disabled={loading}
                  className="btn-buscar"
                >
                  <FaSearch /> Buscar (F1)
                </button>
              </div>
            </div>
          </div>

          {/* Información del pedido */}
          {pedidoSeleccionado && (
            <div className="panel-info-pedido">
              <div className="info-header">
                <h3 className="info-titulo">Información de la Cuenta</h3>
              </div>
              <div className="info-content">
                <div className="info-grid">
                  <div className="info-item">
                    <label>Número de Cuenta:</label>
                    <span>{pedidoSeleccionado.numero}</span>
                  </div>
                  <div className="info-item">
                    <label>Hora Abierto:</label>
                    <span>{pedidoSeleccionado.horaAbierto}</span>
                  </div>
                  <div className="info-item">
                    <label>Fecha:</label>
                    <span>{pedidoSeleccionado.fecha}</span>
                  </div>
                  <div className="info-item">
                    <label>Hora Cerrado:</label>
                    <span>{pedidoSeleccionado.horaCerrado || 'Abierto'}</span>
                  </div>
                  <div className="info-item">
                    <label>Tipo de Cuenta:</label>
                    <span>{pedidoSeleccionado.tipo}</span>
                  </div>
                  <div className="info-item">
                    <label>Quién Generó:</label>
                    <span>{pedidoSeleccionado.mesero}</span>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Productos del pedido */}
          {pedidoSeleccionado && (
            <div className="panel-productos">
              <div className="productos-header">
                <h3 className="productos-titulo">Productos de la Cuenta</h3>
              </div>
              <div className="productos-content">
                <table className="tabla-productos">
                  <thead>
                    <tr>
                      <th>Producto</th>
                      <th>Cantidad</th>
                      <th>Precio</th>
                      <th>Monto</th>
                      <th>Estado</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {productosPedido.length === 0 ? (
                      <tr>
                        <td colSpan="6" className="sin-productos">
                          No hay productos disponibles en esta cuenta
                        </td>
                      </tr>
                    ) : (
                      productosPedido.map((producto, index) => (
                        <tr key={index}>
                          <td>{producto.nombre}</td>
                          <td className="text-center">{producto.cantidad}</td>
                          <td className="text-right">${producto.precio}</td>
                          <td className="text-right">${(producto.cantidad * producto.precio).toFixed(2)}</td>
                          <td>
                            <span className="estado-badge">{producto.estado || 'Normal'}</span>
                          </td>
                          <td className="acciones-cell">
                            <button
                              onClick={() => agregarMalaOrden(producto)}
                              className="btn-accion btn-mala-orden"
                              title="Agregar a Mala Orden"
                            >
                              Mala Orden
                            </button>
                            <button
                              onClick={() => agregarGarantia(producto)}
                              className="btn-accion btn-garantia"
                              title="Agregar a Garantía"
                            >
                              Garantía
                            </button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* Paneles de Mala Orden y Garantía */}
          <div className="paneles-registro">
            {/* Panel Mala Orden */}
            <div className="panel-registro panel-mala-orden">
              <div className="registro-header">
                <h3 className="registro-titulo">Productos a Mala Orden</h3>
              </div>
              <div className="registro-content">
                <table className="tabla-registro">
                  <thead>
                    <tr>
                      <th>Producto</th>
                      <th>Cantidad</th>
                      <th>Precio</th>
                      <th>Monto</th>
                      <th>Motivo</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {productosMalaOrden.length === 0 ? (
                      <tr>
                        <td colSpan="6" className="sin-productos">
                          No hay productos en mala orden
                        </td>
                      </tr>
                    ) : (
                      productosMalaOrden.map((producto, index) => (
                        <tr key={index}>
                          <td>{producto.nombre}</td>
                          <td className="text-center">{producto.cantidad}</td>
                          <td className="text-right">${producto.precio}</td>
                          <td className="text-right">${(producto.cantidad * producto.precio).toFixed(2)}</td>
                          <td>
                            <input
                              type="text"
                              value={producto.motivo}
                              onChange={(e) => actualizarMotivo(producto.idProducto, e.target.value, 'malaOrden')}
                              placeholder="Motivo..."
                              className="input-motivo"
                            />
                          </td>
                          <td>
                            <button
                              onClick={() => removerMalaOrden(producto)}
                              className="btn-remover"
                              title="Remover"
                            >
                              <FaTimes />
                            </button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Panel Garantía */}
            <div className="panel-registro panel-garantia">
              <div className="registro-header">
                <h3 className="registro-titulo">Productos a Garantía</h3>
              </div>
              <div className="registro-content">
                <table className="tabla-registro">
                  <thead>
                    <tr>
                      <th>Producto</th>
                      <th>Cantidad</th>
                      <th>Precio</th>
                      <th>Monto</th>
                      <th>Motivo</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {productosGarantia.length === 0 ? (
                      <tr>
                        <td colSpan="6" className="sin-productos">
                          No hay productos en garantía
                        </td>
                      </tr>
                    ) : (
                      productosGarantia.map((producto, index) => (
                        <tr key={index}>
                          <td>{producto.nombre}</td>
                          <td className="text-center">{producto.cantidad}</td>
                          <td className="text-right">${producto.precio}</td>
                          <td className="text-right">${(producto.cantidad * producto.precio).toFixed(2)}</td>
                          <td>
                            <input
                              type="text"
                              value={producto.motivo}
                              onChange={(e) => actualizarMotivo(producto.idProducto, e.target.value, 'garantia')}
                              placeholder="Motivo..."
                              className="input-motivo"
                            />
                          </td>
                          <td>
                            <button
                              onClick={() => removerGarantia(producto)}
                              className="btn-remover"
                              title="Remover"
                            >
                              <FaTimes />
                            </button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* Botón de guardar */}
          {(productosMalaOrden.length > 0 || productosGarantia.length > 0) && (
            <div className="acciones-footer">
              <button
                onClick={guardarCambios}
                disabled={guardando}
                className="btn-guardar-principal"
              >
                <FaSave /> {guardando ? 'Guardando...' : 'Guardar Registros'}
              </button>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default MalasOrdenesGarantias;